(function() {

	// TODO: can we use :has CSS class (91%) and color-scheme CSS property (92%) instead?
	// TODO: defer loading this script, as we now have <meta name="color-scheme" content="light dark" />

	const settings = {
		id: 'theme-dark',
		on: {
			value: 'on',
			norsk: 'mørk',
			icon: '<path style="stroke:currentColor;stroke-width:1.75;stroke-linejoin:round;fill:currentColor" d="M6 2c-4 6 4 14 10 10,-7 13 -23 -3 -10 -10z"/>',
			disable: false,
			media: false
		},
		off: {
			value: 'off',
			norsk: 'lys',
			icon: '<path style="stroke:currentColor;stroke-width:1;stroke-linecap:round" d="M8.5 3v-2.8M12.7 4.3l2-2M14 8.5h2.8M12.7 12.7l2 2M8.5 14v2.8M4.3 12.7l-2 2M3 8.5h-2.8M2.6 2.6l2 2"/><circle style="fill:currentColor;stroke:none" r="3.5" cy="8.5" cx="8.5"/>',
			disable: true,
			media: true
		},
		auto: {
			value: 'auto',
			norsk: 'auto',
			icon: '<circle style="fill:none;stroke:currentColor;stroke-width:1.5" r="8.25" cy="9" cx="9"/><path style="fill:currentColor;stroke:none" d="M9 3c8 0 8 12 0 12Z"/>',
			disable: false,
			media: true
		}
	}
	settings.off.next = settings.on;
	settings.auto.next = settings.off;
	settings.on.next = settings.auto;
	// Disable dark stylesheet by default for now, in future set auto as default
	settings.default = settings.off;

	const updateControl = function(control) {
		// sets button content
		// called from createControl() and updateLinks()
		control.innerHTML = `<svg fill="currentColor" stroke="none" viewBox="0 0 18 18" class="icon">${theme.icon}</svg> Tema: ${theme.norsk}`;
	}

	const createControl = function(event) {
		// add button to bottom to change dark mode
		// called from domcontentloaded
		const control = document.createElement('button');
		control.type = 'button';
		control.addEventListener('click', setMode);
		if (!document.querySelector('.theme-control')) {
			const container = document.createElement('div');
			container.classList.add('theme-control');
			document.querySelector('body').appendChild(container);
		}
		document.querySelector('.theme-control').appendChild(control);
		updateControl(control);
	}

	const setMode = function(event) {
		// change the theme
		// called from button click event
		theme = theme.next;
		localStorage.setItem(settings.id, theme.value);
		updateLinks();
	}

	const updateLinks = function() {
		// update style elements to load required stylesheets
		// called from domcontentloaded and setmode()
		const styleSheets = document.querySelectorAll('link[media]');
		for (let i = 0; i < styleSheets.length; i++) {
			if (!styleSheets[i].dataset.mediaorg) { styleSheets[i].dataset.mediaorg = styleSheets[i].media; }
			if (/prefers-color-scheme:\s*dark/.test(styleSheets[i].dataset.mediaorg)) {
				styleSheets[i].disabled = theme.disable;
				styleSheets[i].media = theme.media ? styleSheets[i].dataset.mediaorg : styleSheets[i].media.replace(/prefers-color-scheme:\s*dark/, 'width>0');
				// replace the rule with one that is allways true; "(rule) and ()", "rule and" and "rule and all" do not work
				// not removing the whole media attribute, because there theoretically could be a compound media rule
			}
		}
		const control = document.querySelector('.theme-control button');
		if (control) updateControl(control);
	}

	// get theme from querystring parameter
	let theme = settings[new URLSearchParams(window.location.search).get(settings.id)];
	if (theme) {
		localStorage.setItem(settings.id, theme.value);
	}
	// if no theme in querystring parameter, then get from localstorage
	if (!theme) {
		theme = settings[localStorage.getItem(settings.id)];
	}
	// create button to switch theme
	window.addEventListener('DOMContentLoaded', createControl);
	// load defaults if no theme selected
	theme = theme || settings.default;
	// update any style links that are already available
	updateLinks();
	// update any style links that are added to the page later
	window.addEventListener('DOMContentLoaded', updateLinks);

})();
